export default {
  'menu.dashboard': '首页看板',
  'pages.dashboard.action.refresh': '刷新',
  'pages.dashboard.ai.activeUsers': '活跃用户',
  'pages.dashboard.ai.avgLatencyMs': '平均延迟',
  'pages.dashboard.ai.avgResponseTimeMs': '平均响应时间',
  'pages.dashboard.ai.caCalls': 'CA 调用',
  'pages.dashboard.ai.completionTokens': '补全 Token',
  'pages.dashboard.ai.cost': '费用',
  'pages.dashboard.ai.errorCalls': '异常调用',
  'pages.dashboard.ai.failedCalls': '失败调用',
  'pages.dashboard.ai.inputTokens': '输入 Token',
  'pages.dashboard.ai.mbotCalls': 'Mbot 调用',
  'pages.dashboard.ai.modelDistribution': '模型分布',
  'pages.dashboard.ai.outputTokens': '输出 Token',
  'pages.dashboard.ai.promptTokens': '提示 Token',
  'pages.dashboard.ai.successCalls': '成功调用',
  'pages.dashboard.ai.successRate': '成功率',
  'pages.dashboard.ai.title': 'AI 运营看板',
  'pages.dashboard.ai.today': '今日数据',
  'pages.dashboard.ai.totalCalls': '调用总数',
  'pages.dashboard.ai.totalGroups': '群组总数',
  'pages.dashboard.ai.totalTokens': 'Token 总数',
  'pages.dashboard.ai.totalUsers': '用户总数',
  'pages.dashboard.ai.tokens': 'Token 数',
  'pages.dashboard.ai.trend': '趋势数据',
  'pages.dashboard.ai.yesterday': '昨日数据',
  'pages.dashboard.chart.metricFilter': '指标筛选',
  'pages.dashboard.chart.selectMetrics': '选择指标',
  'pages.dashboard.empty.aiRemote': '暂无 AI 运营数据',
  'pages.dashboard.empty.chart': '暂无趋势数据',
  'pages.dashboard.empty.overview': '暂无总览数据',
  'pages.dashboard.empty.risk': '暂无风控数据',
  'pages.dashboard.empty.riskList': '暂无记录',
  'pages.dashboard.empty.segments': '暂无用户结构数据',
  'pages.dashboard.empty.statusBreakdown': '暂无状态数据',
  'pages.dashboard.empty.timApp': '暂无 TIM 应用运营数据',
  'pages.dashboard.empty.timAppList': '暂无记录',
  'pages.dashboard.field.date': '日期',
  'pages.dashboard.growth.activeUsers': '活跃用户',
  'pages.dashboard.growth.newUsers': '新增用户',
  'pages.dashboard.growth.newVipUsers': '新增 VIP 用户',
  'pages.dashboard.growth.profileCompletedUsers': '完善资料用户',
  'pages.dashboard.growth.title': '用户增长趋势',
  'pages.dashboard.growth.totalUsers': '总用户数',
  'pages.dashboard.meetings.callDialCount': '今日拨打次数',
  'pages.dashboard.meetings.createCount': '今日创建会议',
  'pages.dashboard.meetings.title': '今日会议指标',
  'pages.dashboard.meetings.trendTitle': '会议趋势',
  'pages.dashboard.message.aiRemoteFailed': 'AI 运营数据加载失败：{reason}',
  'pages.dashboard.message.growthFailed': '用户增长趋势加载失败：{reason}',
  'pages.dashboard.message.meetingDailyFailed': '会议趋势加载失败：{reason}',
  'pages.dashboard.message.meetingsTodayFailed':
    '今日会议指标加载失败：{reason}',
  'pages.dashboard.message.ordersTodayFailed': '今日订单指标加载失败：{reason}',
  'pages.dashboard.message.overviewFailed': '用户运营总览加载失败：{reason}',
  'pages.dashboard.message.riskFailed': '风控治理数据加载失败：{reason}',
  'pages.dashboard.message.segmentsFailed': '用户结构分布加载失败：{reason}',
  'pages.dashboard.message.timAppFailed': 'TIM 应用运营数据加载失败：{reason}',
  'pages.dashboard.overview.activeUsers': '活跃用户',
  'pages.dashboard.overview.bannedUsers': '封禁用户',
  'pages.dashboard.overview.blockUsers': '拉黑用户',
  'pages.dashboard.overview.complainants': '投诉用户',
  'pages.dashboard.overview.complaints': '投诉数',
  'pages.dashboard.overview.disabledUsers': '禁用用户',
  'pages.dashboard.overview.newUsers': '新增用户',
  'pages.dashboard.overview.newVipUsers': '新增 VIP 用户',
  'pages.dashboard.overview.onlineUsers': '在线用户',
  'pages.dashboard.overview.profileCompletedUsers': '完善资料用户',
  'pages.dashboard.overview.profileCompletionRate': '资料完善率',
  'pages.dashboard.overview.reportedTargets': '被投诉用户',
  'pages.dashboard.overview.risk': '风控',
  'pages.dashboard.overview.riskUsers': '风险用户',
  'pages.dashboard.overview.tim': 'TIM',
  'pages.dashboard.overview.tim.activeUserNum': '活跃用户数',
  'pages.dashboard.overview.tim.apnsMsgNum': 'APNS 消息数',
  'pages.dashboard.overview.tim.appId': '应用 ID',
  'pages.dashboard.overview.tim.c2cApnsMsgNum': 'C2C APNS 消息数',
  'pages.dashboard.overview.tim.c2cDownMsgNum': 'C2C 下行消息数',
  'pages.dashboard.overview.tim.c2cSendMsgUserNum': 'C2C 发消息用户数',
  'pages.dashboard.overview.tim.c2cUpMsgNum': 'C2C 上行消息数',
  'pages.dashboard.overview.tim.callbackReq': '回调请求数',
  'pages.dashboard.overview.tim.callbackRsp': '回调响应数',
  'pages.dashboard.overview.tim.chainDecrease': '环比减少',
  'pages.dashboard.overview.tim.chainIncrease': '环比增长',
  'pages.dashboard.overview.tim.date': '日期',
  'pages.dashboard.overview.tim.downMsgNum': '下行消息数',
  'pages.dashboard.overview.tim.groupAllGroupNum': '群组总数',
  'pages.dashboard.overview.tim.groupApnsMsgNum': '群组 APNS 消息数',
  'pages.dashboard.overview.tim.groupDestroyGroupNum': '解散群组数',
  'pages.dashboard.overview.tim.groupDownMsgNum': '群组下行消息数',
  'pages.dashboard.overview.tim.groupJoinGroupTimes': '入群次数',
  'pages.dashboard.overview.tim.groupNewGroupNum': '新增群组数',
  'pages.dashboard.overview.tim.groupQuitGroupNum': '退群次数',
  'pages.dashboard.overview.tim.groupQuitGroupTimes': '退群次数',
  'pages.dashboard.overview.tim.groupSendMsgGroupNum': '发消息群组数',
  'pages.dashboard.overview.tim.groupSendMsgNum': '群组发消息数',
  'pages.dashboard.overview.tim.groupSendMsgUserNum': '群组发消息用户数',
  'pages.dashboard.overview.tim.groupUpMsgNum': '群组上行消息数',
  'pages.dashboard.overview.tim.loginTimes': '登录次数',
  'pages.dashboard.overview.tim.loginUserNum': '登录用户数',
  'pages.dashboard.overview.tim.mau': '月活用户',
  'pages.dashboard.overview.tim.maxOnlineNum': '最高在线用户数',
  'pages.dashboard.overview.tim.qq': 'QQ',
  'pages.dashboard.overview.tim.registUserNum': '注册用户数',
  'pages.dashboard.overview.tim.registUserNumOne': '新增注册用户数',
  'pages.dashboard.overview.tim.registUserNumOneDay': '今日新增注册用户数',
  'pages.dashboard.overview.tim.registUserNumTotal': '累计注册用户数',
  'pages.dashboard.overview.tim.sendMsgUserNum': '发消息用户数',
  'pages.dashboard.overview.tim.upMsgNum': '上行消息数',
  'pages.dashboard.overview.timUsers': 'TIM 用户',
  'pages.dashboard.overview.title': '用户运营总览',
  'pages.dashboard.overview.totalUsers': '总用户数',
  'pages.dashboard.overview.user': '用户',
  'pages.dashboard.overview.verifiedUsers': '认证用户',
  'pages.dashboard.overview.vipUsers': 'VIP 用户',
  'pages.dashboard.orders.activeUsers': '活跃用户',
  'pages.dashboard.orders.orderCount': '今日订单数',
  'pages.dashboard.orders.refundAmount': '退款金额',
  'pages.dashboard.orders.refundCount': '退款笔数',
  'pages.dashboard.orders.revenue': '今日收入',
  'pages.dashboard.orders.statusBreakdown': '订单状态分布',
  'pages.dashboard.orders.title': '今日订单指标',
  'pages.dashboard.orders.totalOrders': '累计订单数',
  'pages.dashboard.risk.bannedUsers': '封禁用户',
  'pages.dashboard.risk.blockCount': '拉黑次数',
  'pages.dashboard.risk.blockedUid': '被拉黑 UID',
  'pages.dashboard.risk.blockedUsers': '被拉黑用户',
  'pages.dashboard.risk.blockerUid': '拉黑方 UID',
  'pages.dashboard.risk.complainantUid': '投诉人 UID',
  'pages.dashboard.risk.complainantCount': '投诉用户数',
  'pages.dashboard.risk.complainants': '投诉用户',
  'pages.dashboard.risk.complaintCount': '投诉次数',
  'pages.dashboard.risk.complaintType': '投诉类型',
  'pages.dashboard.risk.complaintTypeDistribution': '投诉类型分布',
  'pages.dashboard.risk.complaints': '投诉数',
  'pages.dashboard.risk.count': '数量',
  'pages.dashboard.risk.date': '日期',
  'pages.dashboard.risk.disabledUsers': '禁用用户',
  'pages.dashboard.risk.from': '开始日期',
  'pages.dashboard.risk.keyword': '关键词',
  'pages.dashboard.risk.rank': '第',
  'pages.dashboard.risk.reason': '原因',
  'pages.dashboard.risk.reportCount': '举报次数',
  'pages.dashboard.risk.reportedTargetCount': '被投诉用户数',
  'pages.dashboard.risk.reportedTargets': '被投诉用户',
  'pages.dashboard.risk.reportedUid': '被投诉 UID',
  'pages.dashboard.risk.riskScore': '风险分',
  'pages.dashboard.risk.targetUid': '目标 UID',
  'pages.dashboard.risk.title': '风控治理',
  'pages.dashboard.risk.to': '结束日期',
  'pages.dashboard.risk.topBlocked': '被拉黑用户排行',
  'pages.dashboard.risk.topBlockers': '拉黑用户排行',
  'pages.dashboard.risk.topComplainants': '投诉用户排行',
  'pages.dashboard.risk.topReportedTargets': '被投诉用户排行',
  'pages.dashboard.risk.total': '总数',
  'pages.dashboard.risk.uid': 'UID',
  'pages.dashboard.segments.age': '年龄分布',
  'pages.dashboard.segments.banned': '封禁',
  'pages.dashboard.segments.disabled': '禁用',
  'pages.dashboard.segments.female': '女性',
  'pages.dashboard.segments.gender': '性别分布',
  'pages.dashboard.segments.level': '等级分布',
  'pages.dashboard.segments.male': '男性',
  'pages.dashboard.segments.normal': '正常',
  'pages.dashboard.segments.other': '其他',
  'pages.dashboard.segments.region': '地区分布',
  'pages.dashboard.segments.status': '状态分布',
  'pages.dashboard.segments.title': '用户结构分布',
  'pages.dashboard.segments.unknown': '未知',
  'pages.dashboard.segments.vip': 'VIP 分布',
  'pages.dashboard.segments.vipLevel': 'VIP 等级分布',
  'pages.dashboard.timApp.callbackChain': '回调与环比',
  'pages.dashboard.timApp.groupActivity': '群组活跃',
  'pages.dashboard.timApp.messageTraffic': '消息流量',
  'pages.dashboard.timApp.record': '记录',
  'pages.dashboard.timApp.title': 'TIM 应用运营',
  'pages.dashboard.timApp.today': '今日数据',
  'pages.dashboard.timApp.trend': '趋势数据',
  'pages.dashboard.timApp.userActivity': '用户活跃',
  'pages.dashboard.title': '首页看板',
  'pages.dashboard.updatedAt': '更新时间：{time}',
};
